"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stmt = void 0;
/**

   # Stmt and Command Pattern

   A `Stmt` is like a method of `Mod`,
   but implemented as an independent Command class.

   Unlike `Exp`, `Core`, `Value` and `Neutral`,
   which are closed ADT that will **not** be extended often.
   `Stmt` is an open abstract class that will be extended more often.

   Unlike functions about `Exp`, `Core`, `Value` and `Neutral`,
   which are pure, `stmt.execute` does side effects on `mod`.

**/
class Stmt {
    undo(mod) { }
}
exports.Stmt = Stmt;
//# sourceMappingURL=Stmt.js.map